// 优质产品列表
export const jourList = `/api/unoauth/qualityGoods/listQualityGoods`;
// 优质产品详情
export const journalDetail = `/api/unoauth/qualityGoods/getQualityGoods`;
